import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { st, classes } from './Widget.st.css';
import { Header } from './Header/Header';
import { Body } from './Body/Body';
import { useWidgetViewModel } from '../hooks/useWidgetViewModel';
import Dialog from '../../../shared/components/Dialog/Dialog';
import { useEnvironment } from '@wix/yoshi-flow-editor';

export const Widget: React.FC = () => {
  const { isInitDataLoading, dialogViewModel } = useWidgetViewModel();
  const { isMobile, isRTL } = useEnvironment();

  return (
    <div
      className={st(classes.root, { isMobile, isRTL })}
      dir={isRTL ? 'rtl' : 'ltr'}
      data-hook="DailyAgenda-wrapper"
    >
      <Header />
      <Divider className={classes.divider} />
      {!isInitDataLoading && <Body />}
      {dialogViewModel && <Dialog viewModel={dialogViewModel} />}
    </div>
  );
};
